module.exports = __webpack_public_path__ + "img/g2Icon.13c6f79e.png";